export function previewDescriptor(message) {
  if (!message) return null;
  return {contentType:Number(message.raw?.contentType??message.contentType)||0,type:message.type||'',status:message.status||'',direction:message.direction||'',attachmentName:message.attachment?.name||message.fileElem?.fileName||''};
}
export function conversationPreview(item,t) {
  let message=item.previewMessage;
  if (!Object.prototype.hasOwnProperty.call(item,'previewMessage')) {
    const latest=item.raw?.latestMsg;
    try{message=typeof latest==='string'?JSON.parse(latest):latest;}catch{message=null;}
  }
  const type=Number(message?.raw?.contentType??message?.contentType);
  if(type===1201)return t('system.friendAdded');
  if((type===2101||message?.status==='recalled')&&item.subtitle)return t('system.recalled');
  if(type===102||message?.type==='image')return t('system.image');
  if(type===103||message?.type==='voice')return t('system.voice');
  if(type===105||message?.type==='file')return `${t('system.file')} ${message?.attachmentName||message?.fileElem?.fileName||''}`.trim();
  return item.subtitle||'';
}
export function connectionLabel(text,connected,t) {
  const keys={'已连接':'connected','未连接':'disconnected','连接中':'connecting','连接失败':'failed','同步中':'syncing','同步失败':'syncFailed'};
  return t('connection.'+(keys[text]||(connected?'connected':text?'failed':'disconnected')));
}
